import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=2f2f3515&scoped=true&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"
import style0 from "./Button.vue?vue&type=style&index=0&id=2f2f3515&scoped=true&lang=scss&"
import style1 from "./Button.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2f3515",
  null
  
)

export default component.exports